"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getCanvasDimensionsScaledForImage = function (cvWidth, imageWidth, imageHeight) {
    if (imageWidth <= cvWidth) {
        return [imageWidth, imageHeight, 1];
    }
    var scalingRatio = cvWidth / imageWidth;
    return [cvWidth, scalingRatio * imageHeight, scalingRatio];
};
exports.getCanvasDimensionsScaledForImage = getCanvasDimensionsScaledForImage;
//# sourceMappingURL=canvasHelpers.js.map